import { Component } from "react";
import Layout from "../../component/layout";
import NextSeoModule from "../../component/next-seo";
import Javafulltemplate from "../../component/course/java-full-stack-developer";

export default class Javafullstackinbangalore extends Component {
  render() {
    const title = "Java Full Stack Developer"
    const url= "java-full-stack-developer"
     const url1 ="-course-in-bangalore"
    const location = "bangalore" 
    const location1="Course in Bangalore"
    return(
      <>
        <NextSeoModule
          title={`${title} ${location1} - learnsoft.org`}
          description={`Master the Art of Full Stack Development with Our Comprehensive Java Course in ${location}. Acquire In-demand Skills for Modern Web Development. Enroll Now!`}
          url={`${location}/${url}${url1}`}
          img={`course/${url}.webp`}
          keyword={`${title} training in ${location}, ${title} certification in ${location}, Online ${title}  Training in ${location}, ${title} Online Training in ${location}, ${title} Syllabus, ${title} course in ${location}, ${title} classes in ${location}, ${title} institute in ${location}, Best ${title} training institute in ${location}, ${title} training and certification in ${location}, Best ${title} training in ${location}, ${title} coaching in ${location}, ${title} training center in ${location}, ${title} training provider in ${location}`}
        />
         <Layout navbarBackgroundColor="#281E1E">
        <Javafulltemplate url={url} title={title} url1={"-course-in-bangalore"} relatedlocation={location} location={location} location1={location1} />
     </Layout>
      </>
    );
  }
}
